// import {getEnumItemByValue, NEWS_TYPES} from "../common/enums";
import RatingSettings from "../entities/ratingSettings";

const ratingSettingsDataTransformationAfterFetch = (data) => {
    return new RatingSettings(data);
};

export default ratingSettingsDataTransformationAfterFetch;
